

















































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
	GetDiscodeList,
	InsertDiscode,
	UpdateDiscodeById,
	DeleteDiscode,
	GetAutCodeList
} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import {DeleteAssay, GetAssays, SaveAssay} from "@/api/assay"

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	valueInput(){
		if (this.dialogForm.minValue && this.dialogForm.maxValue) {
			this.dialogForm.otherValue = this.dialogForm.minValue + '~' + this.dialogForm.maxValue
		}
	}
	columns = [
		{
			key: 'itemName',
			title: '化验单单项名称'
		},
		{
			key: 'maxValue',
			title: '最大值'
		},
		{
			key: 'minValue',
			title: '最小值'
		},
		{
			key: 'otherValue',
			title: '参考值'
		},
		{
			key: 'unit',
			title: '单位'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm:any = {
		itemCode: '',
		itemName: '',
		pinYin: '',
		wuBi: '',
		minValue: '',
		maxValue: '',
		otherValue: '',
		unit: '',
		price: '',
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '130px'
	tableTotalSize = 0
	tableData = []
	units = []
	tableLoading = false
	created() {
		this.getSelect()
		this.getData()
	}
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.pinyin = res1
		this.dialogForm.wubi = res2
	}
	createCounty() {
		this.dialogForm = {
			isCommon: false
		}
		this.dialogTitle = '新增化验单单项'
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetAssays({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.objects
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑化验单单项'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteAssay({Id: row.id})
			this.getData()
		}).catch(() => {});
	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				// this.dialogForm.otherValue = this.dialogForm.minValue + '~' + this.dialogForm.maxValue
				console.log(this.dialogForm)
				let res = await SaveAssay(this.dialogForm)
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}
	rules = {
		itemName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		pinyin:[{required: true, message: '请输入内容', trigger: 'blur'}],
		wubi:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
	private async getSelect() {
		let res1 = await GetAutCodeList({Page:1, PageSize:10000})
		this.units = res1.items
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayItem/index.vue